import styled from '@emotion/styled';
import ToolTipIcon from '@/public/icons/tooltip.svg';

const Container = styled.div`
  position: relative;
  display: inline-block;
`;

const StyledSVGButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  > svg {
    vertical-align: middle;
  }
`;

const ToolTip = styled(ToolTipIcon)`
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
  border-radius: 4px;
  &.active {
    opacity: 1;
  }
  &:hover {
    background-color: var(--dk-bg-strong, #e7e9ec);
  }
`;

const Menu = styled.div`
  position: absolute;
  top: 40px;
  right: 0;
  background: var(--dk-bg, #fff);
  border-radius: 8px;
  padding: 8px;
  min-width: 160px;
  z-index: 1000;
  box-shadow: 0px 16px 32px 0px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const MenuItem = styled.button`
  width: 100%;
  padding: 4px 12px;
  background: transparent;
  border: none;
  text-align: left;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  display: block;
  color: var(--dk-text, black);
  border-radius: 4px;
  &:hover {
    background-color: var(--dk-bg-subtle, #f5f5f5);
  }
`;

export { Container, StyledSVGButton, ToolTip, Menu, MenuItem };
